import { render, staticRenderFns } from "./addEmp.vue?vue&type=template&id=6a090af3"
import script from "./addEmp.vue?vue&type=script&lang=js"
export * from "./addEmp.vue?vue&type=script&lang=js"
import style0 from "./addEmp.vue?vue&type=style&index=0&id=6a090af3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports